export default __webpack_public_path__ + "static/N0205-60a27634d1941a713080162e79a9aadd.png";